import { Injectable } from "@angular/core";
import { SwPush } from "@angular/service-worker";
import { Subject } from "rxjs";
import { PushNotification } from "../models/push-notification.model";
import { SignalRMessageParametersModel } from "../models/signalR-message-parameters.model";
import { ApiService } from "./api.service";
import { SignalrChatService } from "./signalr-chat.service";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private readonly swPush: SwPush,
    private readonly signalrChatService: SignalrChatService,
    private readonly api: ApiService
  ) { }

  public readonly notification = new Subject<PushNotification>();

  public get signalrChatHubconnectionId(): string | undefined { return this.signalrChatService.connectionId; }

  private _webpushSubscriptionStr: string | undefined;
  public get webpushSubscriptionStr(): string | undefined { return this._webpushSubscriptionStr; }


  private _requestWebpushPromise?: Promise<PushSubscription | void>;

  public requestWebpushSubscriptionIfNot(options: { serverPublicKey: string }): Promise<PushSubscription | void> {
    if (!this._requestWebpushPromise) {
      this._requestWebpushPromise = this.swPush.requestSubscription(options)
        .then(sub => {
          this._webpushSubscriptionStr = JSON.stringify(sub.toJSON());
          return sub;
        })
        .catch(reason => console.error(reason));
    }
    return this._requestWebpushPromise;
  }

  public async unsubscribeWebpush(): Promise<void> {
    const subscription = this._webpushSubscriptionStr;
    this._webpushSubscriptionStr = undefined;
    this.swPush.unsubscribe();
    this.removePushSubscriber(subscription);
  }

  public registerWebpushSubscription(expir: string) {
    if (!this._webpushSubscriptionStr)
      throw new Error('PushSubscription not initialized.');

    this._webpushSubscriptionStr = JSON.stringify({ expir, ...JSON.parse(this._webpushSubscriptionStr) });
    this.swPush.messages.subscribe((mess: { notification?: PushNotification }) => {
      // alert(JSON.stringify(mess));
      console.log(mess);
      if (mess.notification && !this.checkIfHandled(mess.notification?.data?.traceId))
        this.notification.next(mess.notification);
    });
    this.swPush.notificationClicks.subscribe(data => {
      // alert(JSON.stringify(data));
      console.log('notificationClicks', data);
    });
    this.savePushSubscriber();
  }

  public signalrStartIfNot(accessToken: string): Promise<void> {
    return this.signalrChatService.startIfNot(accessToken);
  }

  public subscribeSignalR() {
    this.signalrChatService.on('NewMessage', (data: SignalRMessageParametersModel) => {
      if (this.checkIfHandled(data?.traceId)) return;
      this.notification.next({
        title: 'Новое сообщение!',
        body: data.text,
        data: { ...data },
      });
    });
    this.signalrChatService.on('MessageEdit', (data: SignalRMessageParametersModel) => {
      if (this.checkIfHandled(data?.traceId)) return;
        this.notification.next({ data });
    });
  }


  private _handledTraceIds: string[] = [];

  private checkIfHandled(traceId?: string): boolean {
    if (! traceId || this._handledTraceIds.includes(traceId)) {
      console.log(`Ignore handled traceId ${traceId}`);
      return true;
    }

    if (this._handledTraceIds.length > 500) {
      const limitTime = new Date().getTime() / 1000 - 60;
      const limitValue = Math.floor(limitTime).toString(16) + '0000000000000000';
      this._handledTraceIds = this._handledTraceIds.filter(v => v > limitValue);
      console.log(`Clear handled traceIds`, JSON.stringify(this._handledTraceIds));
    }

    this._handledTraceIds.push(traceId);
    return false;
  }


  public async savePushSubscriber(): Promise<any> {
    return await this.api.notification.savePushSubscriber(this._webpushSubscriptionStr).then();
  }

  public async removePushSubscriber(subscription: string | undefined): Promise<any> {
    return await this.api.notification.removePushSubscriber(subscription).then();
  }
}
